/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export function getCookie(name) {
  return document.cookie
    .split(';')
    ?.find(s => s?.includes(`${name}=`))
    ?.split('=')[1];
}

export function setCookie({ name, value }) {
  document.cookie = `${name}=${value}; path=/`;
}

export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}
